import React from 'react'
import { connect } from 'react-redux';

import hiredImg from 'assets/img/hired.svg'

import {
  Content,
  Image,
  Title,
  SubTitle
} from './styles'

const FinalStep = ({ taskQuoteProDetail }) => {
  return (
    <Content>
      <Title>CONTRATAÇÃO EFETUADA</Title>
      <SubTitle>O profissional {taskQuoteProDetail.user_name} irá&nbsp;<b>confirmar a data marcada </b>&nbsp;em breve.</SubTitle>
      <SubTitle>Se você tiver qualquer problema, entre em contato com a gente!</SubTitle>
      <Image src={hiredImg}/>
    </Content>
  )
}

const mapStateToProps = state => ({
  taskQuoteProDetail: state.task.taskQuoteProDetail,
});


export default connect(
  mapStateToProps
)(FinalStep)

